import { NgModule } from '@angular/core';
import { LibOpenLinkIconComponent } from './lib-open-link-icon.component';

@NgModule({
  declarations: [LibOpenLinkIconComponent],
  imports: [],
  exports: [LibOpenLinkIconComponent],
})
export class LibOpenLinkIconModule {}
